module.exports = __webpack_public_path__ + "img/39_74.ee67eea3.png";